module.exports = __webpack_public_path__ + "static/media/klima-07.b6f8654f.jpg";